import React, { useState, useEffect, useRef, useCallback } from 'react'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import { toast } from 'react-toastify'
import { apiIDW, apiLabs, apiSantoLog } from '../../../Services/api'
import Dashboard from '../../../Components/Dashboard'
import { apiToLocal as areaApiToLocal, pointInPoly as ptInPoly } from './areaUtils'
import { isInBrazil, isInUF, CITY_COORDS as ORD_CITY_COORDS, normCityKey } from './orderUtils'
import {
  GlobalMapStyles, PageWrap, TabsBar, TabBtn, TabBadge,
  MapScreen, MapWrap, Sidebar, StatsRow, StatCard,
  GruposHeader, BtnNewGroup, GruposList, NoGroups, UnassignedFooter,
  GCard, GCardHead, GChevron, GSwatch, GName, GBtn, GStats, GStat,
  GOrders, GOrderRow, GOrderNum, GOrderKg, GOrderMove,
  MoveDrop, MoveMenu, MoveMenuItem, MoveMenuDivider,
  MapContainer, MapDiv, BoxRect, PolyHint, MapCtrl, CtrlBtn, MapStatus, NewBtn,
  SelBar, SelInfo, SelCount, SelWeight, SelReassignInfo,
  SelActions, SelClear, SelCreate, SelAssignWrap, SelAssign, AssignMenu,
  AssignMenuTitle, AssignMenuItem,
  ProgressScreen, ProgBox, ProgTrack, ProgFill, ProgMeta, ProgCancel,
  OrdersScreen, OrdersToolbar, OrdersSearch, OrdersToolbarActions, OrdersToolBtn,
  OrdersContent, StatusGroup, StatusGroupHead, StatusGroupChevron,
  StatusGroupName, StatusGroupMetrics, StatusGroupBody,
  OrdersTable, ColPed, ColCidade, ColCep, ColDate, ColPeso, ColTransp,
  DriverPill, DriverNone, OrdersEmpty,
  ModalOverlay, ModalBox, ModalSummary, MStat, ModalActions, ModalCancel, ModalConfirm,
  ModalEditActions, BtnAddSel, BtnEmptySel,
  GRoutePanel, RouteSpinner, RouteInfoBar, RouteMetric, RouteWarn,
  RouteToggles, RouteToggle, RouteActions, RouteBtn, GRouteBtnStyled,
  StopsEditor, StopsEditorTitle, RouteStopRow, StopDrag, StopNum,
  StopInfo, StopPed, StopCity, StopArrows, StopArrow, StopLinks,
  AreasScreen, AreasToolbar, AreasSummary, ASumStat,
  AreasContent, AreasEmpty,
  AreaStatCard, AreaStatHead, AreaStatSwatch, AreaStatName, AreaStatCarrier,
  AreaStatRow, AreaStatMetric, AreaStatBar, AreaStatBarFill,
  StatusFilterBar, StatusFilterLabel, StatusChip, StatusChipCount, StatusClearBtn,
} from './style'
import { store } from '../../../store'
import history from '../../../Services/history'
import Denied from '../../../Components/Denied'

// ─── CONSTANTS ────────────────────────────────────────────────────────────────
const EXCLUDED = new Set(['aberto', 'devolvido', 'em devolução', 'cancelado'])

// Filtros de status disponíveis na UI. `match` é a substring (normalizada — sem
// acento, lowercase) que deve aparecer no campo "STATUS PED." do pedido.
const STATUS_FILTERS = [
  { id: 'aguardando', label: 'Aguardando romaneio', match: 'aguardando romaneio' },
  { id: 'separacao',  label: 'Em separação',        match: 'em separac' },
  { id: 'fechado',    label: 'Fechado',             match: 'fechado' },
]
function normalizeStr(s) {
  // remove diacríticos (acentos) via decomposição NFD + regex compilado de ̀-ͯ
  return String(s || '').toLowerCase().normalize('NFD').replace(new RegExp('[\\u0300-\\u036f]', 'g'), '').trim()
}
// v10: invalida v9 (que aceitava coords erradas dentro do UF — ex: CEP 06030-319 caía a 280km de Osasco/SP)
const LS_KEY = 'santolog_geocache_v10'
const GROUP_PALETTE = ['#3b82f6', '#f59e0b', '#ec4899', '#a855f7', '#06b6d4',
  '#f97316', '#10b981', '#6366f1', '#e879f9', '#84cc16',
  '#fb923c', '#14b8a6', '#8b5cf6', '#ef4444', '#0ea5e9']
const STATUS_PALETTE = ['#00e5a0', '#3b82f6', '#f59e0b', '#a855f7', '#06b6d4',
  '#ec4899', '#10b981', '#f97316', '#6366f1', '#84cc16', '#f43f5e']
const DEFAULT_MARKER = '#4a5a72'
const MY_LOCATION = {
  name: 'Meu Local', address: 'Rua Teófilo Dias, 145',
  neighborhood: 'Vila Regente Feijó', city: 'São Paulo', state: 'SP',
  cep: '03344030', lat: -23.5654, lng: -46.5280,
}

const CITY_COORDS = {
  "são paulo|sp": [-23.5505, -46.6333], "rio de janeiro|rj": [-22.9068, -43.1729],
  "brasília|df": [-15.7801, -47.9292], "brasilia|df": [-15.7801, -47.9292],
  "salvador|ba": [-12.9714, -38.5014], "fortaleza|ce": [-3.7172, -38.5434],
  "belo horizonte|mg": [-19.9167, -43.9345], "manaus|am": [-3.1190, -60.0217],
  "curitiba|pr": [-25.4290, -49.2671], "recife|pe": [-8.0578, -34.8829],
  "porto alegre|rs": [-30.0346, -51.2177], "belém|pa": [-1.4554, -48.4898],
  "goiânia|go": [-16.6869, -49.2648], "florianópolis|sc": [-27.5954, -48.5480],
  "são luís|ma": [-2.5297, -44.3028], "maceió|al": [-9.6658, -35.7350],
  "natal|rn": [-5.7945, -35.2120], "teresina|pi": [-5.0919, -42.8034],
  "campo grande|ms": [-20.4428, -54.6460], "joão pessoa|pb": [-7.1195, -34.8450],
  "aracaju|se": [-10.9095, -37.0748], "porto velho|ro": [-8.7619, -63.9039],
  "cuiabá|mt": [-15.6014, -56.0979], "macapá|ap": [0.0356, -51.0705],
  "rio branco|ac": [-9.9754, -67.8249], "palmas|to": [-10.2491, -48.3243],
  "boa vista|rr": [2.8235, -60.6758], "vitória|es": [-20.3222, -40.3381],
  "guarulhos|sp": [-23.4543, -46.5335], "campinas|sp": [-22.9056, -47.0608],
  "são bernardo do campo|sp": [-23.6914, -46.5646], "santo andré|sp": [-23.6737, -46.5382],
  "osasco|sp": [-23.5324, -46.7920], "ribeirão preto|sp": [-21.1775, -47.8208],
  "sorocaba|sp": [-23.5015, -47.4526], "mauá|sp": [-23.6678, -46.4614],
  "diadema|sp": [-23.6861, -46.6228], "jundiaí|sp": [-23.1864, -46.8964],
  "carapicuíba|sp": [-23.5225, -46.8354], "mogi das cruzes|sp": [-23.5228, -46.1886],
  "santos|sp": [-23.9619, -46.3322], "piracicaba|sp": [-22.7253, -47.6492],
  "são josé dos campos|sp": [-23.2237, -45.9009], "bauru|sp": [-22.3246, -49.0703],
  "contagem|mg": [-19.9317, -44.0536], "juiz de fora|mg": [-21.7642, -43.3503],
  "são josé do rio preto|sp": [-20.8197, -49.3794], "londrina|pr": [-23.3045, -51.1696],
  "maringá|pr": [-23.4273, -51.9375], "joinville|sc": [-26.3045, -48.8487],
  "blumenau|sc": [-26.9195, -49.0661], "feira de santana|ba": [-12.2664, -38.9663],
  "anápolis|go": [-16.3281, -48.9530], "uberlândia|mg": [-18.9133, -48.2775],
  "caxias do sul|rs": [-29.1678, -51.1795], "pelotas|rs": [-31.7654, -52.3375],
  "nova iguaçu|rj": [-22.7556, -43.4558], "duque de caxias|rj": [-22.7861, -43.3116],
  "niterói|rj": [-22.8832, -43.1034], "cajamar|sp": [-23.3581, -46.8772],
  "nova lima|mg": [-19.9849, -43.8471], "varginha|mg": [-21.5513, -45.4305],
  "ponta grossa|pr": [-25.0916, -50.1619], "cascavel|pr": [-24.9555, -53.4552],
  "chapecó|sc": [-27.1005, -52.6156], "criciúma|sc": [-28.6780, -49.3697],
  "itajaí|sc": [-26.9078, -48.6614], "vitória da conquista|ba": [-14.8661, -40.8444],
  "barueri|sp": [-23.5047, -46.8763], "cotia|sp": [-23.6029, -46.9196],
  "taubaté|sp": [-23.0268, -45.5556], "franca|sp": [-20.5386, -47.4006],
  "limeira|sp": [-22.5643, -47.4014], "suzano|sp": [-23.5426, -46.3114],
  "sumaré|sp": [-22.8219, -47.2672], "indaiatuba|sp": [-23.0904, -47.2186],
  "praia grande|sp": [-24.0059, -46.4019],
}

// ─── PURE HELPERS ─────────────────────────────────────────────────────────────
function loadCache() {
  try {
    for (let i = 2; i <= 9; i++) localStorage.removeItem('santolog_geocache_v' + i)
    return JSON.parse(localStorage.getItem(LS_KEY) || '{}')
  } catch { return {} }
}
function saveCache(cache) {
  try { localStorage.setItem(LS_KEY, JSON.stringify(cache)) } catch { }
}
function normCep(v) { return String(v || '').replace(/\D/g, '').padStart(8, '0') }
function normKey(c, u) { return `${String(c || '').toLowerCase().trim()}|${String(u || '').toLowerCase().trim()}` }
function parsePeso(v) {
  if (v === null || v === undefined || v === '') return 0
  const n = parseFloat(String(v).replace(',', '.'))
  return isNaN(n) ? 0 : n
}
function fmtKg(n) { return n.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) }
function uid() { return Date.now().toString(36) + Math.random().toString(36).slice(2, 6) }
function sleep(ms) { return new Promise(r => setTimeout(r, ms)) }
function escHtml(s) {
  return String(s == null ? '' : s).replace(/[&<>"']/g, c =>
    ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]))
}
function haversine(a, b) {
  const R = 6371, toRad = d => d * Math.PI / 180
  const dLat = toRad(b[0] - a[0]), dLng = toRad(b[1] - a[1])
  const s = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(a[0])) * Math.cos(toRad(b[0])) * Math.sin(dLng / 2) ** 2
  return 2 * R * Math.asin(Math.sqrt(s))
}
function fmtDistance(m) {
  return m < 1000 ? Math.round(m) + ' m' : (m / 1000).toFixed(1).replace('.', ',') + ' km'
}
function fmtDuration(s) {
  const mins = Math.round(s / 60)
  if (mins < 60) return mins + ' min'
  const h = Math.floor(mins / 60), r = mins % 60
  return h + 'h ' + (r > 0 ? r + 'min' : '')
}
function getStatusColor(status) {
  const s = (status || '').toLowerCase()
  if (/entreg/.test(s) && !/não.*entreg/.test(s)) return '#10b981'
  if (/aguard|pendente|romaneio/.test(s)) return '#f59e0b'
  if (/trânsito|rota|saída|enviado|expedi/.test(s)) return '#3b82f6'
  if (/prepar|separa|picking/.test(s)) return '#06b6d4'
  if (/problema|ocorr|falha|erro/.test(s)) return '#ef4444'
  if (/retorno|devolv|recusa/.test(s)) return '#f43f5e'
  let h = 0
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0
  return STATUS_PALETTE[h % STATUS_PALETTE.length]
}
function pointInPoly(lat, lng, verts) {
  let inside = false
  for (let i = 0, j = verts.length - 1; i < verts.length; j = i++) {
    const xi = verts[i].lng, yi = verts[i].lat
    const xj = verts[j].lng, yj = verts[j].lat
    if (((yi > lat) !== (yj > lat)) && (lng < (xj - xi) * (lat - yi) / (yj - yi) + xi)) inside = !inside
  }
  return inside
}

// Mapper: API response → internal order format (adjust field names as needed)
function mapOrderFromApi(item) {
  const g = (...keys) => { for (const k of keys) { if (item[k] != null && item[k] !== '') return item[k] } return '' }
  return {
    'STATUS PED.': g('StatusOrder', 'statusOrder', 'status', 'STATUS PED.', 'Status'),
    'CIDADE': g('City', 'city', 'cidade', 'CIDADE', 'Cidade', 'ShippingCity'),
    'UF': g('State', 'state', 'uf', 'UF', 'ShippingState'),
    'CEP': g('ZipCode', 'zipCode', 'cep', 'CEP', 'PostalCode', 'ShippingPostalCode'),
    'PEDIDO': g('Order', 'order', 'pedido', 'PEDIDO', 'IDOrder', 'NrOrder', 'NrPedido'),
    'TRANSPORTADORA': g('Carrier', 'carrier', 'transportadora', 'TRANSPORTADORA', 'CarrierName', 'SupplierNameCorporateName'),
    'PESO (KG)': g('Weight', 'weight', 'peso', 'PESO (KG)', 'WeightKg'),
    'DT CRIAÇÃO': g('CreatedAt', 'createdAt', 'dtCriacao', 'DT CRIAÇÃO', 'DtCriacao', 'Recordtimestamp'),
    'DT ENTREGA EST.': g('EstimatedDelivery', 'estimatedDelivery', 'DT ENTREGA EST.', 'DtEntregaEst', 'ShippingEstimateDate'),
  }
}

// Route optimization
function nearestNeighbor(origin, stops) {
  const remaining = stops.slice(), order = []
  let cur = origin
  while (remaining.length) {
    let bestIdx = 0, bestDist = Infinity
    for (let i = 0; i < remaining.length; i++) {
      const d = haversine(cur, [remaining[i]._lat, remaining[i]._lng])
      if (d < bestDist) { bestDist = d; bestIdx = i }
    }
    const next = remaining.splice(bestIdx, 1)[0]
    order.push(next); cur = [next._lat, next._lng]
  }
  return order
}
function twoOpt(origin, stops, returnHome) {
  if (stops.length < 4) return stops
  const coords = s => [s._lat, s._lng]
  const pathDist = arr => {
    let sum = 0, prev = origin
    for (const s of arr) { sum += haversine(prev, coords(s)); prev = coords(s) }
    if (returnHome) sum += haversine(prev, origin)
    return sum
  }
  let best = stops.slice(), bestDist = pathDist(best), improved = true, iter = 0
  while (improved && iter < 40) {
    improved = false; iter++
    for (let i = 0; i < best.length - 1; i++) {
      for (let j = i + 1; j < best.length; j++) {
        const c = best.slice(0, i).concat(best.slice(i, j + 1).reverse()).concat(best.slice(j + 1))
        const d = pathDist(c)
        if (d < bestDist - 0.001) { best = c; bestDist = d; improved = true }
      }
    }
  }
  return best
}
function optimizeStops(origin, stops, returnHome) {
  if (!stops.length) return []
  return twoOpt(origin, nearestNeighbor(origin, stops), returnHome)
}
async function fetchOsrmRoute(waypoints) {
  const coords = waypoints.map(w => `${w[1]},${w[0]}`).join(';')
  const url = `https://router.project-osrm.org/route/v1/driving/${coords}?overview=full&geometries=geojson&steps=false`
  const r = await fetch(url, { signal: AbortSignal.timeout(15000) })
  if (!r.ok) throw new Error('OSRM HTTP ' + r.status)
  const d = await r.json()
  if (d.code !== 'Ok' || !d.routes?.[0]) throw new Error('OSRM: ' + (d.message || 'sem rota'))
  const route = d.routes[0]
  return {
    latlngs: route.geometry.coordinates.map(c => [c[1], c[0]]),
    distance: route.distance,
    duration: route.duration,
  }
}

// ─── COMPONENT ────────────────────────────────────────────────────────────────
export default function SantoLogMaps(props) {

  const { location: { idPage } } = props
  const [auth, setAuth] = useState(null)
  async function verifyAuth() {
    const { profile } = store.getState().user
    const res = await apiLabs.post('valid_key', { id: profile.id, menu_id: idPage })
    if (res.data.message === "User not authorized") {
      return setAuth('denied')
    }
    if (res.data.message === "User authorized") {
      return setAuth('authorized')
    }
    return history.push({ pathname: '/', state: { from: props.location } })
  }

  // React UI state
  const [screen, setScreen] = useState('progress') // 'progress' | 'map'
  const [currentView, setCurrentView] = useState('map')      // 'map' | 'orders' | 'areas'
  const [progress, setProgress] = useState({ title: 'Conectando...', sub: 'Buscando pedidos na API', pct: 0, l: '', r: '' })
  const [modalOpen, setModalOpen] = useState(false)
  const [modalInput, setModalInput] = useState('')
  const [ordersQuery, setOrdersQuery] = useState('')
  const [, forceUpdate] = useState(0)
  const rerender = useCallback(() => forceUpdate(n => n + 1), [])

  // Áreas cadastradas (vindas do santolog/area) — só leitura aqui, edição é em /santolog/areas
  const [areas, setAreas] = useState([])
  const [showAreas, setShowAreas] = useState(true)
  const [ordersVersion, setOrdersVersion] = useState(0) // bumpa após buildMap p/ refrescar stats
  const [mapReady, setMapReady] = useState(false)        // dispara re-render quando o mapa fica pronto
  const areasLayerRef = useRef(null)
  const autoAssignedRef = useRef(false)                  // garante auto-atribuição uma única vez

  // Filtro de status dos pedidos — Set de ids dos STATUS_FILTERS selecionados.
  // Vazio = sem filtro (mostra tudo). Com seleção = só pedidos com algum dos status marcados.
  const [selectedStatuses, setSelectedStatuses] = useState(() => new Set())
  function toggleStatusFilter(id) {
    setSelectedStatuses(prev => {
      const next = new Set(prev)
      if (next.has(id)) next.delete(id); else next.add(id)
      return next
    })
  }
  function clearStatusFilter() { setSelectedStatuses(new Set()) }

  // Retorna true se o pedido passa pelo filtro de status (ou se não há filtro ativo)
  function passesStatusFilter(o) {
    if (!selectedStatuses.size) return true
    const st = normalizeStr(o['STATUS PED.'])
    for (const f of STATUS_FILTERS) {
      if (selectedStatuses.has(f.id) && st.includes(f.match)) return true
    }
    return false
  }

  // Mutable state (read by Leaflet callbacks — using refs to avoid stale closures)
  const S = useRef({
    orders: [], groups: [], selectedIds: new Set(),
    carrierColors: {}, transpColorIdx: 0,
    expandedGroups: new Set(), expandedStatusGroups: new Set(),
    statusGroupsInitialized: false,
    routeState: {},           // { groupId: { active, polyline, outline, order, distance, duration, straight, optimize, returnHome, loading } }
    openMoveMenuId: null,
    assignMenuOpen: false,
    selMode: null,            // null | 'box' | 'poly'
    boxDrag: false, boxStart: { x: 0, y: 0 },
    polyVerts: [], polyLatLng: [],
    editingGroupId: null,
    dragSrc: { gid: null, idx: null },
    openStopsEditor: null,
    geoErrors: [],
    cancelFlag: false,
    mapStatus: '—',
    myLat: MY_LOCATION.lat, myLng: MY_LOCATION.lng,
  })
  const s = S.current

  // Leaflet refs
  const mapDivRef = useRef(null)
  const mapRef = useRef(null)   // L.Map instance
  const markersLayerRef = useRef(null)
  const orderMarkersRef = useRef({})     // { orderId → L.Marker }
  const homeMarkerRef = useRef(null)
  const geoCache = useRef(loadCache())
  const cancelFlagRef = useRef(false)

  // DOM refs for SVG polygon drawing
  const polySvgRef = useRef(null)
  const polyShapeRef = useRef(null)
  const polyLineRef = useRef(null)
  const polyCloseRef = useRef(null)
  const polyDotsRef = useRef(null)
  const polyHintRef = useRef(null)
  const mapContRef = useRef(null)
  const boxRectRef = useRef(null)

  // ── MAP INIT (lazy — fires after MapScreen becomes visible) ──────────────────
  useEffect(() => {
    return () => { if (mapRef.current) { mapRef.current.remove(); mapRef.current = null } }
  }, []) // eslint-disable-line

  useEffect(() => {
    if (screen !== 'map') return
    const rafId = requestAnimationFrame(() => {
      if (!mapDivRef.current) return
      if (!mapRef.current) {
        const map = L.map(mapDivRef.current, { zoomControl: false }).setView([-15.8, -47.9], 5)
        L.tileLayer('https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png', {
          attribution: '© OpenStreetMap © CARTO', subdomains: 'abcd', maxZoom: 19,
        }).addTo(map)
        L.control.zoom({ position: 'bottomright' }).addTo(map)
        mapRef.current = map
      }
      mapRef.current.invalidateSize()
      addHomeMarker()
      renderMarkers()
      fitAll()
      setMapReady(true) // dispara o effect que renderiza o layer de áreas
    })
    return () => cancelAnimationFrame(rafId)
  }, [screen]) // eslint-disable-line

  // ── API FETCH ───────────────────────────────────────────────────────────────
  useEffect(() => {
    fetchOrders()
    fetchAreas()
    verifyAuth()
  }, []) // eslint-disable-line

  async function fetchOrders() {
    try {
      const res = await apiIDW.get('/orders', {
        params: { IDStatusOrder: '1,20,22', IDCarrier: '11268,48922,1905' },
      })
      const raw = Array.isArray(res.data) ? res.data : (res.data?.data || res.data?.orders || [])
      const rows = raw.map(mapOrderFromApi).filter(r => {
        const st = (r['STATUS PED.'] || '').toLowerCase().trim()
        return !EXCLUDED.has(st) && normCep(r['CEP']).length >= 5
      })
      await kickGeo(rows)
    } catch (err) {
      setProgress(p => ({ ...p, title: 'Erro ao buscar pedidos', sub: String(err.message || err) }))
    }
  }

  async function fetchAreas() {
    try {
      const res = await apiSantoLog.get('/area')
      const list = Array.isArray(res.data) ? res.data : (res.data?.data || res.data?.areas || [])
      const mapped = list.map(a => areaApiToLocal(a)).filter(a => a.coordinates.length >= 3)
      setAreas(mapped)
    } catch (err) {
      console.error('GET /area failed:', err)
      toast.error('Erro ao carregar áreas: ' + (err?.response?.data?.error || err?.response?.data?.message || err.message))
    }
  }

  // ── AUTO-ATRIBUIÇÃO ────────────────────────────────────────────────────────
  // Quando áreas e pedidos estão carregados, cria grupos a partir dos motoristas
  // já vinculados nas áreas e atribui automaticamente os pedidos contidos em cada
  // área. Roda APENAS uma vez (ref `autoAssignedRef`) para preservar mudanças
  // manuais do usuário (drag pra outro motorista, etc.).
  // Sem validação de peso/quantidade nem persistência no banco — UI-only por ora.
  function autoAssignOrdersFromAreas() {
    if (!s.orders.length || !areas.length) return
    // Agrupa áreas por motorista
    const byDriver = new Map() // driver_id → { name, color, areas: [] }
    for (const a of areas) {
      if (!a.driver_id) continue
      let bucket = byDriver.get(a.driver_id)
      if (!bucket) {
        bucket = {
          name: a.driver_name || `Motorista ${byDriver.size + 1}`,
          color: a.color || GROUP_PALETTE[byDriver.size % GROUP_PALETTE.length],
          carrier_id: a.carrier_id || null,
          areas: [],
        }
        byDriver.set(a.driver_id, bucket)
      }
      bucket.areas.push(a)
    }
    if (byDriver.size === 0) return

    let touchedOrders = 0
    for (const [driverId, info] of byDriver) {
      // Procura grupo já criado para este motorista (re-runs idempotentes)
      let group = s.groups.find(g => g.driver_id === driverId)
      if (!group) {
        group = {
          id: uid(),
          name: info.name,
          color: info.color,
          driver_id: driverId,
          carrier_id: info.carrier_id,
          orderIds: [],
          autoCreated: true,
        }
        s.groups.push(group)
      }
      // Atribui pedidos dentro de qualquer área do motorista (só os ainda sem grupo)
      for (const o of s.orders) {
        if (o._group) continue
        for (const a of info.areas) {
          if (pointInPoly(o._lat, o._lng, a.coordinates)) {
            o._group = group.id
            if (group.orderIds && !group.orderIds.includes(o._id)) group.orderIds.push(o._id)
            touchedOrders++
            break
          }
        }
      }
    }
    if (touchedOrders > 0) {
      renderMarkers()
      rerender()
      toast.success(`${touchedOrders} pedido${touchedOrders !== 1 ? 's' : ''} atribuído${touchedOrders !== 1 ? 's' : ''} automaticamente a ${byDriver.size} motorista${byDriver.size !== 1 ? 's' : ''}`)
    }
  }

  // Dispara a auto-atribuição uma única vez por sessão, quando áreas+pedidos prontos
  useEffect(() => {
    if (autoAssignedRef.current) return
    if (!areas.length || !s.orders.length) return
    autoAssignedRef.current = true
    autoAssignOrdersFromAreas()
  }, [areas, ordersVersion]) // eslint-disable-line

  // Re-renderiza os markers do mapa quando o filtro de status muda
  useEffect(() => {
    if (screen === 'map' && mapRef.current && s.orders.length) renderMarkers()
  }, [selectedStatuses]) // eslint-disable-line


  // Re-renderiza o layer de áreas sempre que a lista, o screen ou o toggle mudam
  useEffect(() => {
    if (screen !== 'map' || !mapRef.current) return
    if (areasLayerRef.current) {
      mapRef.current.removeLayer(areasLayerRef.current)
      areasLayerRef.current = null
    }
    if (!showAreas || !areas.length) return
    const layer = L.layerGroup().addTo(mapRef.current)
    areas.forEach(a => {
      const stats = areaStatsFor(a)
      const poly = L.polygon(a.coordinates.map(c => [c.lat, c.lng]), {
        color: a.color, weight: 2, fillColor: a.color, fillOpacity: 0.10,
        interactive: true,
      })
      poly.bindTooltip(
        `<strong style="color:${a.color}">${escHtml(a.name)}</strong><br/>` +
        `${stats.count} pedido${stats.count !== 1 ? 's' : ''} · ${fmtKg(stats.weight)} kg`,
        { sticky: true, direction: 'top' }
      )
      poly.on('click', e => L.DomEvent.stopPropagation(e))
      poly.addTo(layer)
    })
    areasLayerRef.current = layer
  }, [areas, showAreas, screen, ordersVersion, mapReady]) // eslint-disable-line

  // ── GEOCODING ───────────────────────────────────────────────────────────────
  async function kickGeo(rows) {
    cancelFlagRef.current = false
    const uniqueCeps = [...new Set(rows.map(r => normCep(r['CEP'])))]
    const toFetch = uniqueCeps.filter(cep => !geoCache.current[cep])
    const cached = uniqueCeps.length - toFetch.length

    if (!toFetch.length) {
      setProgress({ title: `${cached} CEPs no cache — carregando mapa!`, sub: 'Nenhuma requisição necessária', pct: 100, l: '', r: '' })
      await sleep(400)
      buildMap(rows)
      return
    }

    // Pool de workers concorrentes — emite o próximo CEP assim que um termina,
    // ao invés de esperar o batch inteiro. Mantém o servidor levemente carregado
    // sem disparar todos de uma vez. ~6 simultâneos é o ponto doce empírico
    // pra AwesomeAPI/BrasilAPI sem hit em rate limit.
    const CONCURRENCY = 6
    setProgress({
      title: `Buscando ${toFetch.length} CEP${toFetch.length > 1 ? 's' : ''}…`,
      sub: `${cached} no cache · ${CONCURRENCY} em paralelo`,
      pct: 0, l: '', r: '',
    })

    let cursor = 0, done = 0, lastSaveAt = 0
    async function worker() {
      while (!cancelFlagRef.current && cursor < toFetch.length) {
        const idx = cursor++
        const cep = toFetch[idx]
        await fetchCep(cep, geoCache.current)
        done++
        const pct = (done / toFetch.length) * 100
        setProgress(p => ({ ...p, pct, l: `${done}/${toFetch.length} CEPs`, r: Math.round(pct) + '%' }))
        // Persiste o cache periodicamente (a cada 20 conclusões), sem bloquear o pool
        if (done - lastSaveAt >= 20) { lastSaveAt = done; saveCache(geoCache.current) }
      }
    }
    await Promise.all(Array.from({ length: Math.min(CONCURRENCY, toFetch.length) }, worker))

    saveCache(geoCache.current)
    if (!cancelFlagRef.current) buildMap(rows)
  }

  // Coleta candidatos de lat/lng dos APIs e cidade/UF informados, depois aceita o
  // primeiro par que cair dentro do bounding box do UF (ou do Brasil se UF não conhecido).
  // Isso evita gravar coords erradas no cache — caso histórico: CEP 08507-220
  // (Itaquaquecetuba/SP) caía em outro estado porque uma das APIs devolveu coords
  // inconsistentes com o UF que ela mesma declarou.
  async function fetchCep(cep, cache) {
    const MAX_KM_FROM_CITY = 50 // raio aceitável de "candidato vs centro da cidade conhecida"
    let knownCity = null, knownState = null, knownAddress = null
    const candidates = []

    // 1. AwesomeAPI
    try {
      const r = await fetch(`https://cep.awesomeapi.com.br/json/${cep}`, { signal: AbortSignal.timeout(8000) })
      if (r.ok) {
        const d = await r.json()
        knownCity = knownCity || d?.city || null
        knownState = knownState || d?.state || null
        knownAddress = knownAddress || d?.address || null
        const lat = parseFloat(d?.lat), lng = parseFloat(d?.lng)
        if (Number.isFinite(lat) && Number.isFinite(lng) && (lat !== 0 || lng !== 0)) {
          candidates.push([lat, lng, 'awesomeapi'])
        }
      }
    } catch { }

    // 2. BrasilAPI v2
    try {
      const r = await fetch(`https://brasilapi.com.br/api/cep/v2/${cep}`, { signal: AbortSignal.timeout(8000) })
      if (r.ok) {
        const d = await r.json()
        knownCity = knownCity || d?.city || null
        knownState = knownState || d?.state || null
        knownAddress = knownAddress || d?.street || null
        const lat = parseFloat(d?.location?.coordinates?.latitude)
        const lng = parseFloat(d?.location?.coordinates?.longitude)
        if (Number.isFinite(lat) && Number.isFinite(lng) && (lat !== 0 || lng !== 0)) {
          candidates.push([lat, lng, 'brasilapi'])
        }
      }
    } catch { }

    // 3. Nominatim por CEP — só se nada veio das APIs primárias (evita rate limit)
    if (!candidates.length) {
      try {
        const r = await fetch(
          `https://nominatim.openstreetmap.org/search?postalcode=${cep}&countrycodes=br&format=json&limit=1`,
          { headers: { 'User-Agent': 'santoLog/1.0' }, signal: AbortSignal.timeout(10000) })
        const d = await r.json()
        if (d?.[0]) {
          const lat = parseFloat(d[0].lat), lng = parseFloat(d[0].lon)
          if (Number.isFinite(lat) && Number.isFinite(lng)) candidates.push([lat, lng, 'nominatim-cep'])
        }
      } catch { }
    }

    // Aceita o primeiro candidato que esteja dentro do UF conhecido
    // (ou dentro do Brasil, quando o UF não está disponível) E, se a cidade for
    // conhecida no CITY_COORDS, dentro de ~50km do centro dessa cidade.
    //
    // Por que a checagem por cidade: o UF de SP (por exemplo) cobre ~250.000 km²,
    // então uma coordenada errada pode passar pela validação de UF e ainda assim
    // estar a 300km da cidade certa. Caso real: CEP 06030-319 (Osasco/SP) →
    // AwesomeAPI devolveu (-23.08, -49.54), dentro de SP mas a ~280km de Osasco.
    for (const [lat, lng, src] of candidates) {
      if (!isInBrazil(lat, lng)) continue
      if (knownState && !isInUF(lat, lng, knownState)) {
        console.warn(`[geocode] CEP ${cep}: descartando ${src} (${lat},${lng}) — fora de ${knownState}`)
        continue
      }
      if (knownCity && knownState) {
        const cityCoords = ORD_CITY_COORDS[normCityKey(knownCity, knownState)]
        if (cityCoords) {
          const distKm = haversine([lat, lng], cityCoords)
          if (distKm > MAX_KM_FROM_CITY) {
            console.warn(`[geocode] CEP ${cep}: descartando ${src} (${lat},${lng}) — ${Math.round(distKm)}km longe de ${knownCity}/${knownState}`)
            continue
          }
        }
      }
      cache[cep] = [lat, lng]
      return
    }

    // 4. Nominatim por cidade — última chance, validada também (UF + raio da cidade)
    if (knownCity) {
      try {
        const q = knownAddress
          ? `${knownAddress}, ${knownCity}, ${knownState || 'Brazil'}`
          : `${knownCity}, ${knownState || 'Brazil'}`
        const r = await fetch(
          `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(q)}&countrycodes=br&format=json&limit=1`,
          { headers: { 'User-Agent': 'santoLog/1.0' }, signal: AbortSignal.timeout(10000) })
        const d = await r.json()
        if (d?.[0]) {
          const lat = parseFloat(d[0].lat), lng = parseFloat(d[0].lon)
          if (!isInBrazil(lat, lng)) return
          if (knownState && !isInUF(lat, lng, knownState)) return
          if (knownCity && knownState) {
            const cityCoords = ORD_CITY_COORDS[normCityKey(knownCity, knownState)]
            if (cityCoords && haversine([lat, lng], cityCoords) > MAX_KM_FROM_CITY) return
          }
          cache[cep] = [lat, lng]
          return
        }
      } catch { }
    }

    cache[cep] = null
  }

  // ── BUILD MAP ───────────────────────────────────────────────────────────────
  function buildMap(rows) {
    const geoErrors = []
    s.orders = rows.map(r => {
      const cep = normCep(r['CEP'])
      const entry = geoCache.current[cep]
      let coords = null, src = '?'
      if (Array.isArray(entry) && entry.length === 2 && !isNaN(entry[0])) { coords = entry; src = 'cep' }
      if (!coords) {
        const ck = normKey(r['CIDADE'], r['UF'])
        if (CITY_COORDS[ck]) { coords = CITY_COORDS[ck]; src = 'cidade' }
      }
      if (!coords) { geoErrors.push({ pedido: r['PEDIDO'] || '?', cep, cidade: (r['CIDADE'] || '') + '/' + (r['UF'] || '') }); return null }
      const jitter = src === 'cidade' ? 0.008 : 0.0001
      return {
        ...r, _id: uid(), _cep: cep, _key: normKey(r['CIDADE'], r['UF']),
        _lat: coords[0] + (Math.random() - 0.5) * jitter,
        _lng: coords[1] + (Math.random() - 0.5) * jitter,
        _peso: parsePeso(r['PESO (KG)']), _group: null, _geoSrc: src,
      }
    }).filter(Boolean)

    s.geoErrors = geoErrors
    s.groups = []; s.selectedIds = new Set()
    s.routeState = {}; s.carrierColors = {}; s.transpColorIdx = 0
    s.statusGroupsInitialized = false
    s.mapStatus = `${s.orders.length} pedido${s.orders.length !== 1 ? 's' : ''}`

    setScreen('map')
    setCurrentView('map')
    setOrdersVersion(v => v + 1) // refresca stats das áreas
  }

  // ── MARKER HELPERS ──────────────────────────────────────────────────────────
  function getMarkerColor(o) {
    if (o._group) { const g = s.groups.find(x => x.id === o._group); if (g) return g.color }
    return DEFAULT_MARKER
  }
  function getOrderRouteNumber(o) {
    if (!o._group) return null
    const rs = s.routeState[o._group]
    if (!rs || !rs.order) return null
    const idx = rs.order.findIndex(x => x._id === o._id)
    return idx >= 0 ? idx + 1 : null
  }
  function makeIcon(color, selected) {
    if (selected) {
      return L.divIcon({
        className: '',
        html: `<div style="position:relative;width:28px;height:28px;display:flex;align-items:center;justify-content:center;">
          <div style="position:absolute;width:28px;height:28px;border-radius:50%;background:${color}30;border:2px solid ${color}88;animation:ringPulse 1.2s ease-out infinite;"></div>
          <div style="width:16px;height:16px;border-radius:50%;background:${color};border:2.5px solid #fff;box-shadow:0 0 10px ${color}cc;z-index:1;"></div>
        </div>`,
        iconSize: [28, 28], iconAnchor: [14, 14],
      })
    }
    return L.divIcon({
      className: '',
      html: `<div style="width:10px;height:10px;border-radius:50%;background:${color};border:2px solid rgba(0,0,0,.6);box-shadow:0 0 4px ${color}55;"></div>`,
      iconSize: [10, 10], iconAnchor: [5, 5],
    })
  }
  function makeNumberedIcon(color, num, selected) {
    const badge = `<div style="width:26px;height:26px;border-radius:50%;background:${color};border:2.5px solid #fff;box-shadow:0 3px 8px rgba(0,0,0,.6);display:flex;align-items:center;justify-content:center;color:#fff;font-family:'Space Mono',monospace;font-size:11px;font-weight:700;line-height:1;">${num}</div>`
    if (selected) {
      return L.divIcon({
        className: '',
        html: `<div style="position:relative;width:38px;height:38px;display:flex;align-items:center;justify-content:center;">
          <div style="position:absolute;width:38px;height:38px;border-radius:50%;background:${color}30;border:2px solid ${color}88;animation:ringPulse 1.2s ease-out infinite;"></div>
          ${badge}</div>`,
        iconSize: [38, 38], iconAnchor: [19, 19],
      })
    }
    return L.divIcon({ className: '', html: badge, iconSize: [26, 26], iconAnchor: [13, 13] })
  }
  function iconForOrder(o) {
    const color = getMarkerColor(o)
    const sel = s.selectedIds.has(o._id)
    const num = getOrderRouteNumber(o)
    return num !== null ? makeNumberedIcon(color, num, sel) : makeIcon(color, sel)
  }

  function renderMarkers() {
    const map = mapRef.current
    if (!map) return
    if (markersLayerRef.current) map.removeLayer(markersLayerRef.current)
    markersLayerRef.current = L.layerGroup().addTo(map)
    orderMarkersRef.current = {}

    s.orders.forEach(o => {
      // Filtro de status: pula pedidos que não passam pelos chips ativos
      if (!passesStatusFilter(o)) return
      const color = getMarkerColor(o)
      const m = L.marker([o._lat, o._lng], { icon: iconForOrder(o) })
      const kg = fmtKg(o._peso)
      m.bindTooltip(
        `<strong>${o['PEDIDO'] || '—'}</strong> · <span style="color:${color}">${kg} kg</span>`,
        { direction: 'top', offset: [0, -5] }
      )
      const cep = String(o['CEP'] || '').replace(/\D/g, '').replace(/(\d{5})(\d{3})/, '$1-$2')
      const grp = o._group ? s.groups.find(g => g.id === o._group) : null
      const num = getOrderRouteNumber(o)
      m.bindPopup(`<div class="pu">
        <div class="pu-ped">${escHtml(o['PEDIDO'] || '—')}${num ? ` · <span style="color:${color}">Parada #${num}</span>` : ''}</div>
        <div class="pu-row"><span class="k">Status</span><span class="v">${escHtml(o['STATUS PED.'] || '—')}</span></div>
        <div class="pu-row"><span class="k">Cidade</span><span class="v">${escHtml(o['CIDADE'] || '—')}/${escHtml(o['UF'] || '—')}</span></div>
        <div class="pu-row"><span class="k">CEP</span><span class="v">${cep || '—'}</span></div>
        <div class="pu-row"><span class="k">Criação</span><span class="v">${escHtml(o['DT CRIAÇÃO'] || '—')}</span></div>
        <div class="pu-row"><span class="k">Prev. Entrega</span><span class="v">${escHtml(o['DT ENTREGA EST.'] || '—')}</span></div>
        ${grp ? `<div class="pu-row"><span class="k">Motorista</span><span class="v" style="color:${grp.color};font-weight:600">${escHtml(grp.name)}</span></div>` : ''}
        <div class="pu-weight"><span class="wlbl">⚖ Peso</span><span class="wval">${kg} kg</span></div>
        <div class="pu-transp">${escHtml(o['TRANSPORTADORA'] || '(sem transportadora)')}</div>
      </div>`, { maxWidth: 240 })

      m.on('click', e => {
        L.DomEvent.stopPropagation(e)
        if (s.selectedIds.has(o._id)) {
          s.selectedIds.delete(o._id)
          m.setIcon(iconForOrder(o))
        } else {
          selectOrder(o)
        }
        rerender()
      })

      m.addTo(markersLayerRef.current)
      orderMarkersRef.current[o._id] = m
    })
  }

  // ── SELECTION ────────────────────────────────────────────────────────────────
  function selectOrder(o) {
    if (s.selectedIds.has(o._id)) return
    s.selectedIds.add(o._id)
    const m = orderMarkersRef.current[o._id]
    if (m) m.setIcon(iconForOrder(o))
  }
  function clearSelection() {
    s.selectedIds.forEach(id => {
      const o = s.orders.find(x => x._id === id)
      if (o && orderMarkersRef.current[id]) orderMarkersRef.current[id].setIcon(iconForOrder(o))
    })
    s.selectedIds = new Set()
    s.assignMenuOpen = false
    rerender()
  }

  // Selection bar computed
  const selOrders = s.orders.filter(o => s.selectedIds.has(o._id))
  const selCount = selOrders.length
  const selWeightV = selOrders.reduce((sum, o) => sum + o._peso, 0)
  const selAssigned = selOrders.filter(o => o._group)

  // ── BOX SELECT ───────────────────────────────────────────────────────────────
  function handleContMouseDown(e) {
    if (s.selMode !== 'box' || e.button !== 0) return
    const r = mapContRef.current.getBoundingClientRect()
    s.boxDrag = true
    s.boxStart = { x: e.clientX - r.left, y: e.clientY - r.top }
    if (boxRectRef.current) {
      boxRectRef.current.style.display = 'block'
      boxRectRef.current.style.left = s.boxStart.x + 'px'
      boxRectRef.current.style.top = s.boxStart.y + 'px'
      boxRectRef.current.style.width = '0'
      boxRectRef.current.style.height = '0'
    }
    e.preventDefault()
  }
  function handleContMouseMove(e) {
    if (!s.boxDrag) return
    const r = mapContRef.current.getBoundingClientRect()
    const cx = e.clientX - r.left, cy = e.clientY - r.top
    const x = Math.min(cx, s.boxStart.x), y = Math.min(cy, s.boxStart.y)
    if (boxRectRef.current) {
      boxRectRef.current.style.left = x + 'px'
      boxRectRef.current.style.top = y + 'px'
      boxRectRef.current.style.width = Math.abs(cx - s.boxStart.x) + 'px'
      boxRectRef.current.style.height = Math.abs(cy - s.boxStart.y) + 'px'
    }
  }
  function handleContMouseUp(e) {
    if (!s.boxDrag) return
    s.boxDrag = false
    if (boxRectRef.current) boxRectRef.current.style.display = 'none'
    const r = mapContRef.current.getBoundingClientRect()
    const cx = e.clientX - r.left, cy = e.clientY - r.top
    const x1 = Math.min(cx, s.boxStart.x), y1 = Math.min(cy, s.boxStart.y)
    const x2 = Math.max(cx, s.boxStart.x), y2 = Math.max(cy, s.boxStart.y)
    if (Math.abs(x2 - x1) < 5 && Math.abs(y2 - y1) < 5) { exitMode(); return }
    const sw = mapRef.current.containerPointToLatLng(L.point(x1, y2))
    const ne = mapRef.current.containerPointToLatLng(L.point(x2, y1))
    const bounds = L.latLngBounds(sw, ne)
    s.orders.forEach(o => { if (bounds.contains([o._lat, o._lng])) selectOrder(o) })
    exitMode()
    rerender()
  }

  // ── POLYGON SELECT ───────────────────────────────────────────────────────────
  function pxStr(verts) { return verts.map(v => `${v.x},${v.y}`).join(' ') }
  function addPolyDot(x, y, first = false) {
    if (!polyDotsRef.current) return
    const c = document.createElementNS('http://www.w3.org/2000/svg', 'circle')
    c.setAttribute('cx', x); c.setAttribute('cy', y)
    c.setAttribute('r', first ? 6 : 4)
    c.setAttribute('fill', first ? '#00e5a0' : '#00e5a0cc')
    c.setAttribute('stroke', '#000'); c.setAttribute('stroke-width', '1.5')
    polyDotsRef.current.appendChild(c)
  }
  function handlePolySvgMouseMove(e) {
    if (s.selMode !== 'poly' || !s.polyVerts.length) return
    const r = mapContRef.current.getBoundingClientRect()
    const cx = e.clientX - r.left, cy = e.clientY - r.top
    if (polyLineRef.current) polyLineRef.current.setAttribute('points', pxStr([...s.polyVerts, { x: cx, y: cy }]))
    if (s.polyVerts.length >= 2 && polyCloseRef.current) {
      const fv = s.polyVerts[0]
      polyCloseRef.current.setAttribute('x1', cx); polyCloseRef.current.setAttribute('y1', cy)
      polyCloseRef.current.setAttribute('x2', fv.x); polyCloseRef.current.setAttribute('y2', fv.y)
      const dist = Math.hypot(cx - fv.x, cy - fv.y)
      polyCloseRef.current.setAttribute('stroke-opacity', dist < 28 ? '0.9' : '0.3')
    }
    if (polyHintRef.current) {
      polyHintRef.current.textContent = s.polyVerts.length >= 3
        ? 'Duplo-clique ou clique no 1° ponto para fechar · ESC cancela'
        : 'Clique para adicionar pontos · ESC cancela'
    }
  }
  function handlePolySvgClick(e) {
    if (s.selMode !== 'poly') return
    e.stopPropagation()
    const r = mapContRef.current.getBoundingClientRect()
    const px = e.clientX - r.left, py = e.clientY - r.top
    if (s.polyVerts.length >= 3) {
      const fv = s.polyVerts[0]
      if (Math.hypot(px - fv.x, py - fv.y) < 20) { finishPolygon(); return }
    }
    const ll = mapRef.current.containerPointToLatLng(L.point(px, py))
    s.polyVerts.push({ x: px, y: py })
    s.polyLatLng.push({ lat: ll.lat, lng: ll.lng })
    addPolyDot(px, py, s.polyVerts.length === 1)
    if (polyShapeRef.current) polyShapeRef.current.setAttribute('points', pxStr(s.polyVerts))
    if (polyLineRef.current) polyLineRef.current.setAttribute('points', pxStr(s.polyVerts))
    if (polyHintRef.current) polyHintRef.current.textContent = s.polyVerts.length < 3
      ? `${s.polyVerts.length} ponto${s.polyVerts.length > 1 ? 's' : ''} · continue clicando`
      : 'Duplo-clique ou clique no 1° ponto para fechar · ESC cancela'
  }
  function handlePolySvgDblClick(e) {
    if (s.selMode !== 'poly') return
    e.stopPropagation(); e.preventDefault()
    if (s.polyVerts.length >= 3) finishPolygon()
  }
  function finishPolygon() {
    const verts = s.polyLatLng.slice()
    s.orders.forEach(o => { if (pointInPoly(o._lat, o._lng, verts)) selectOrder(o) })
    exitMode()
    rerender()
  }

  // ── MODE ENTER/EXIT ──────────────────────────────────────────────────────────
  function enterMode(mode) {
    s.selMode = mode
    mapRef.current?.dragging.disable()
    mapRef.current?.doubleClickZoom.disable()
    if (polySvgRef.current && mode === 'poly') {
      polySvgRef.current.style.display = 'block'
      polySvgRef.current.style.pointerEvents = 'all'
    }
    if (polyHintRef.current && mode === 'poly') {
      polyHintRef.current.style.display = 'block'
      polyHintRef.current.textContent = 'Clique para adicionar pontos · Duplo-clique para fechar'
    }
    rerender()
  }
  function exitMode() {
    s.selMode = null
    mapRef.current?.dragging.enable()
    mapRef.current?.doubleClickZoom.enable()
    s.boxDrag = false
    if (boxRectRef.current) boxRectRef.current.style.display = 'none'
    s.polyVerts = []; s.polyLatLng = []
    if (polySvgRef.current) {
      polySvgRef.current.style.display = 'none'
      polySvgRef.current.style.pointerEvents = 'none'
    }
    if (polyShapeRef.current) polyShapeRef.current.setAttribute('points', '')
    if (polyLineRef.current) polyLineRef.current.setAttribute('points', '')
    if (polyCloseRef.current) {
      polyCloseRef.current.setAttribute('x1', 0); polyCloseRef.current.setAttribute('y1', 0)
      polyCloseRef.current.setAttribute('x2', 0); polyCloseRef.current.setAttribute('y2', 0)
    }
    if (polyDotsRef.current) polyDotsRef.current.innerHTML = ''
    if (polyHintRef.current) polyHintRef.current.style.display = 'none'
    rerender()
  }
  useEffect(() => {
    const onKey = e => { if (e.key === 'Escape' && s.selMode) exitMode() }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }) // eslint-disable-line

  // ── GROUPS ──────────────────────────────────────────────────────────────────
  function openModal() { if (!selCount) return; s.editingGroupId = null; setModalInput(''); setModalOpen(true) }
  function openEditModal(gid) { s.editingGroupId = gid; const g = s.groups.find(x => x.id === gid); setModalInput(g?.name || ''); setModalOpen(true) }
  function closeModal() { setModalOpen(false); s.editingGroupId = null }
  function confirmModal() {
    const name = modalInput.trim()
    if (!name) return
    if (s.editingGroupId) {
      const g = s.groups.find(x => x.id === s.editingGroupId); if (g) g.name = name
    } else {
      const color = GROUP_PALETTE[s.groups.length % GROUP_PALETTE.length]
      const id = uid()
      const oids = [...s.selectedIds]
      s.groups.push({ id, name, color, orderIds: oids })
      oids.forEach(oid => { const o = s.orders.find(x => x._id === oid); if (o) o._group = id })
      s.selectedIds = new Set()
      renderMarkers()
    }
    closeModal()
    rerender()
  }

  function addSelectionToEditing() {
    if (!s.editingGroupId) return
    const g = s.groups.find(x => x.id === s.editingGroupId); if (!g) return
    s.orders.forEach(o => {
      if (s.selectedIds.has(o._id) && !o._group) {
        o._group = s.editingGroupId; g.orderIds.push(o._id)
      }
    })
    s.selectedIds = new Set()
    renderMarkers(); rerender()
  }
  function removeAllFromEditing() {
    if (!s.editingGroupId) return
    if (!window.confirm('Remover todos os pedidos deste motorista?')) return
    s.orders.forEach(o => { if (o._group === s.editingGroupId) o._group = null })
    const g = s.groups.find(x => x.id === s.editingGroupId); if (g) g.orderIds = []
    renderMarkers(); rerender()
  }

  function assignToExistingGroup(gid) {
    const g = s.groups.find(x => x.id === gid); if (!g) return
    const affected = new Set([gid])
    s.selectedIds.forEach(oid => {
      const o = s.orders.find(x => x._id === oid); if (!o) return
      if (o._group && o._group !== gid) {
        affected.add(o._group)
        const old = s.groups.find(x => x.id === o._group)
        if (old) old.orderIds = old.orderIds.filter(id => id !== oid)
      }
      o._group = gid
      if (!g.orderIds.includes(oid)) g.orderIds.push(oid)
    })
    affected.forEach(id => { if (s.routeState[id]?.active) hideRoute(id) })
    s.selectedIds = new Set(); s.assignMenuOpen = false
    renderMarkers(); rerender()
  }

  function moveOrder(oid, targetGid) {
    const o = s.orders.find(x => x._id === oid); if (!o) return
    const affected = new Set()
    if (o._group) {
      affected.add(o._group)
      const old = s.groups.find(x => x.id === o._group)
      if (old) old.orderIds = old.orderIds.filter(id => id !== oid)
    }
    o._group = targetGid || null
    if (targetGid) {
      affected.add(targetGid)
      const ng = s.groups.find(x => x.id === targetGid)
      if (ng && !ng.orderIds.includes(oid)) ng.orderIds.push(oid)
    }
    s.openMoveMenuId = null
    affected.forEach(id => { if (s.routeState[id]?.active) hideRoute(id) })
    renderMarkers(); rerender()
  }

  function deleteGroup(gid) {
    if (!window.confirm('Excluir este motorista? Os pedidos voltarão ao pool.')) return
    hideRoute(gid); delete s.routeState[gid]
    s.orders.forEach(o => { if (o._group === gid) o._group = null })
    s.groups = s.groups.filter(x => x.id !== gid)
    renderMarkers(); rerender()
  }

  function focusGroup(gid) {
    const gOrders = s.orders.filter(o => o._group === gid)
    if (!gOrders.length || !mapRef.current) return
    mapRef.current.fitBounds(L.latLngBounds(gOrders.map(o => [o._lat, o._lng])), { padding: [60, 60] })
  }

  // ── MAP CONTROLS ─────────────────────────────────────────────────────────────
  function fitAll() {
    if (!s.orders.length || !mapRef.current) return
    mapRef.current.fitBounds(L.latLngBounds(s.orders.map(o => [o._lat, o._lng])), { padding: [40, 40] })
  }

  function addHomeMarker() {
    if (!mapRef.current) return
    if (homeMarkerRef.current) { mapRef.current.removeLayer(homeMarkerRef.current); homeMarkerRef.current = null }
    placeHomeMarker(s.myLat, s.myLng)
    resolveMyLocation().then(coords => {
      if (coords) {
        s.myLat = coords[0]; s.myLng = coords[1]
        if (homeMarkerRef.current) homeMarkerRef.current.setLatLng(coords)
      }
    })
  }
  async function resolveMyLocation() {
    try {
      const r = await fetch(`https://cep.awesomeapi.com.br/json/${MY_LOCATION.cep}`, { signal: AbortSignal.timeout(6000) })
      if (r.ok) { const d = await r.json(); const lat = parseFloat(d?.lat), lng = parseFloat(d?.lng); if (lat && lng && !isNaN(lat) && !isNaN(lng)) return [lat, lng] }
    } catch { }
    try {
      const q = `${MY_LOCATION.address}, ${MY_LOCATION.neighborhood}, ${MY_LOCATION.city}, ${MY_LOCATION.state}`
      const r = await fetch(`https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(q)}&countrycodes=br&format=json&limit=1`, { headers: { 'User-Agent': 'santoLog/1.0' }, signal: AbortSignal.timeout(8000) })
      const d = await r.json(); if (d?.[0]) return [parseFloat(d[0].lat), parseFloat(d[0].lon)]
    } catch { }
    return null
  }
  function placeHomeMarker(lat, lng) {
    if (!mapRef.current) return
    if (homeMarkerRef.current) mapRef.current.removeLayer(homeMarkerRef.current)
    const icon = L.divIcon({ className: '', html: `<div class="home-marker" title="Meu Local">🏠</div>`, iconSize: [32, 32], iconAnchor: [16, 16] })
    const m = L.marker([lat, lng], { icon, zIndexOffset: 2000 })
    const cepFmt = MY_LOCATION.cep.replace(/(\d{5})(\d{3})/, '$1-$2')
    m.bindPopup(`<div class="pu"><div class="pu-home-header"><div class="pu-home-title">🏠 ${MY_LOCATION.name}</div><div class="pu-home-addr">${MY_LOCATION.address}<br>${MY_LOCATION.neighborhood} · ${MY_LOCATION.city}/${MY_LOCATION.state}<br><span style="color:#5a6370;font-family:'Space Mono',monospace;font-size:10px">CEP ${cepFmt}</span></div></div></div>`, { maxWidth: 260, className: 'home-popup' })
    m.bindTooltip(`<strong>🏠 ${MY_LOCATION.name}</strong>`, { direction: 'top', offset: [0, -12] })
    m.addTo(mapRef.current)
    homeMarkerRef.current = m
  }
  function goToMyLocation() {
    if (!homeMarkerRef.current || !mapRef.current) return
    mapRef.current.setView([s.myLat, s.myLng], 15, { animate: true })
    homeMarkerRef.current.openPopup()
  }

  function clearCache() {
    geoCache.current = {}
    try { for (let i = 2; i <= 10; i++) localStorage.removeItem('santolog_geocache_v' + i) } catch { }
    setTimeout(() => window.location.reload(), 600)
  }

  function switchView(view) {
    setCurrentView(view)
    if (view === 'map' && mapRef.current) setTimeout(() => mapRef.current.invalidateSize(), 50)
  }

  // ── ROUTING ──────────────────────────────────────────────────────────────────
  async function drawRoute(gid, options = {}) {
    const g = s.groups.find(x => x.id === gid); if (!g) return
    const gOrders = s.orders.filter(o => o._group === gid)
    if (!gOrders.length) { alert('Este motorista não tem pedidos.'); return }
    if (!s.routeState[gid]) s.routeState[gid] = { optimize: true, returnHome: false }
    const rs = s.routeState[gid]
    rs.loading = true; rerender()

    const origin = [s.myLat, s.myLng]
    let orderedStops
    if (options.preComputedOrder) {
      orderedStops = options.preComputedOrder.filter(x => x._group === gid)
      gOrders.forEach(o => { if (!orderedStops.find(x => x._id === o._id)) orderedStops.push(o) })
    } else if (rs.optimize) {
      orderedStops = optimizeStops(origin, gOrders, rs.returnHome)
    } else {
      const idxMap = new Map(s.orders.map((o, i) => [o._id, i]))
      orderedStops = gOrders.slice().sort((a, b) => idxMap.get(a._id) - idxMap.get(b._id))
    }

    const waypoints = [origin, ...orderedStops.map(x => [x._lat, x._lng])]
    if (rs.returnHome) waypoints.push(origin)

    clearRouteLayer(gid)

    let geom, straight = false
    try {
      geom = await fetchOsrmRoute(waypoints)
    } catch {
      let dist = 0
      for (let i = 1; i < waypoints.length; i++) dist += haversine(waypoints[i - 1], waypoints[i]) * 1000
      geom = { latlngs: waypoints, distance: dist, duration: 0 }
      straight = true
    }

    if (!mapRef.current) return
    const outline = L.polyline(geom.latlngs, { color: '#000', weight: 7, opacity: 0.35, lineCap: 'round', lineJoin: 'round' }).addTo(mapRef.current)
    const pl = L.polyline(geom.latlngs, { color: g.color, weight: 4, opacity: 0.92, lineCap: 'round', lineJoin: 'round', dashArray: straight ? '8,6' : null }).addTo(mapRef.current)

    rs.active = true; rs.order = orderedStops; rs.distance = geom.distance
    rs.duration = geom.duration; rs.straight = straight
    rs.outline = outline; rs.polyline = pl; rs.loading = false

    orderedStops.forEach(o => { const m = orderMarkersRef.current[o._id]; if (m) m.setIcon(iconForOrder(o)) })
    rerender()
  }

  function clearRouteLayer(gid) {
    const rs = s.routeState[gid]; if (!rs || !mapRef.current) return
    if (rs.polyline) { mapRef.current.removeLayer(rs.polyline); rs.polyline = null }
    if (rs.outline) { mapRef.current.removeLayer(rs.outline); rs.outline = null }
  }
  function hideRoute(gid) {
    const rs = s.routeState[gid]; if (!rs) return
    clearRouteLayer(gid)
    const prev = rs.order || []; rs.active = false; rs.order = null
    prev.forEach(o => { const m = orderMarkersRef.current[o._id]; if (m) m.setIcon(iconForOrder(o)) })
    rerender()
  }
  function toggleRoute(gid) { s.routeState[gid]?.active ? hideRoute(gid) : drawRoute(gid) }
  function toggleRouteOptimize(gid) {
    if (!s.routeState[gid]) s.routeState[gid] = { optimize: true, returnHome: false }
    s.routeState[gid].optimize = !s.routeState[gid].optimize
    if (s.routeState[gid].active) drawRoute(gid); else rerender()
  }
  function toggleRouteReturn(gid) {
    if (!s.routeState[gid]) s.routeState[gid] = { optimize: true, returnHome: false }
    s.routeState[gid].returnHome = !s.routeState[gid].returnHome
    if (s.routeState[gid].active) drawRoute(gid); else rerender()
  }
  function moveStop(gid, from, to) {
    const rs = s.routeState[gid]; if (!rs?.order) return
    const n = rs.order.length; if (from < 0 || from >= n || to < 0 || to >= n || from === to) return
    const arr = rs.order.slice(); const [moved] = arr.splice(from, 1); arr.splice(to, 0, moved)
    rs.optimize = false; drawRoute(gid, { preComputedOrder: arr })
  }
  function focusRoute(gid) {
    const rs = s.routeState[gid]; if (!rs?.active || !rs.polyline || !mapRef.current) return
    mapRef.current.fitBounds(rs.polyline.getBounds(), { padding: [40, 40] })
  }
  function openInGoogleMaps(gid) {
    const rs = s.routeState[gid]; if (!rs?.order) return
    const origin = `${s.myLat},${s.myLng}`
    const stops = rs.order.map(x => `${x._lat},${x._lng}`)
    const last = rs.returnHome ? origin : stops.pop()
    const wps = stops.slice(0, 9)
    const url = `https://www.google.com/maps/dir/?api=1&origin=${origin}&destination=${last}${wps.length ? `&waypoints=${wps.join('|')}` : ''}&travelmode=driving`
    window.open(url, '_blank')
  }
  function wazeLinkForStop(lat, lng) { return `https://www.waze.com/ul?ll=${lat},${lng}&navigate=yes` }

  // Drag & drop stops
  function onStopDragStart(e, gid, idx) {
    s.dragSrc = { gid, idx }; e.currentTarget.classList.add('dragging')
    e.dataTransfer.effectAllowed = 'move'
    try { e.dataTransfer.setData('text/plain', String(idx)) } catch { }
  }
  function onStopDragOver(e, gid, idx) {
    if (s.dragSrc.gid !== gid) return; e.preventDefault(); e.dataTransfer.dropEffect = 'move'
    const row = e.currentTarget, rect = row.getBoundingClientRect(), midY = rect.top + rect.height / 2
    row.classList.remove('drag-over-top', 'drag-over-bot')
    row.classList.add(e.clientY < midY ? 'drag-over-top' : 'drag-over-bot')
  }
  function onStopDragLeave(e) { e.currentTarget.classList.remove('drag-over-top', 'drag-over-bot') }
  function onStopDrop(e, gid, idx) {
    if (s.dragSrc.gid !== gid) return; e.preventDefault()
    e.currentTarget.classList.remove('drag-over-top', 'drag-over-bot')
    const rect = e.currentTarget.getBoundingClientRect(), midY = rect.top + rect.height / 2
    let toIdx = e.clientY < midY ? idx : idx + 1
    if (s.dragSrc.idx < toIdx) toIdx--
    const src = s.dragSrc.idx; s.dragSrc = { gid: null, idx: null }
    if (toIdx !== src) moveStop(gid, src, toIdx)
  }
  function onStopDragEnd(e) {
    e.currentTarget.classList.remove('dragging')
    document.querySelectorAll('.route-stop-row').forEach(r => r.classList.remove('drag-over-top', 'drag-over-bot'))
    s.dragSrc = { gid: null, idx: null }
  }

  function focusOrderOnMap(oid) {
    const o = s.orders.find(x => x._id === oid); if (!o) return
    switchView('map')
    setTimeout(() => {
      mapRef.current?.setView([o._lat, o._lng], 15, { animate: true })
      orderMarkersRef.current[oid]?.openPopup()
    }, 120)
  }

  // ── COMPUTED ──────────────────────────────────────────────────────────────────
  // `visibleOrders` é o conjunto base após o filtro de status — afeta stats,
  // áreas, badges e a aba Pedidos. Markers do mapa usam o mesmo filtro via renderMarkers.
  const visibleOrders = selectedStatuses.size === 0
    ? s.orders
    : s.orders.filter(passesStatusFilter)
  const totalKg = visibleOrders.reduce((sum, o) => sum + o._peso, 0)
  const unassigned = visibleOrders.filter(o => !o._group)
  const unassignedKg = unassigned.reduce((sum, o) => sum + o._peso, 0)

  // Contagem de pedidos por status (no conjunto total, ignorando o filtro atual) —
  // mostrado nos chips pra orientar o usuário.
  const statusCounts = (() => {
    const counts = {}
    for (const f of STATUS_FILTERS) counts[f.id] = 0
    for (const o of s.orders) {
      const st = normalizeStr(o['STATUS PED.'])
      for (const f of STATUS_FILTERS) {
        if (st.includes(f.match)) counts[f.id]++
      }
    }
    return counts
  })()

  // Pedidos por área (point-in-polygon) — recomputa quando areas/orders/filtro mudam
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const areasWithStats = (() => {
    if (!areas.length) return []
    return areas.map(a => {
      const ords = visibleOrders.filter(o => ptInPoly(o._lat, o._lng, a.coordinates))
      const weight = ords.reduce((sum, o) => sum + o._peso, 0)
      return { ...a, orderCount: ords.length, totalWeight: weight, orders: ords }
    })
  })()
  const ordersInAnyArea = areasWithStats.reduce((s, a) => s + a.orderCount, 0)
  const ordersOutOfAreas = visibleOrders.length - ordersInAnyArea
  const weightInAnyArea = areasWithStats.reduce((s, a) => s + a.totalWeight, 0)
  const weightOutOfAreas = totalKg - weightInAnyArea

  function areaStatsFor(a) {
    const ords = visibleOrders.filter(o => ptInPoly(o._lat, o._lng, a.coordinates))
    return { count: ords.length, weight: ords.reduce((sum, o) => sum + o._peso, 0) }
  }

  // Filtered orders for orders view (busca textual + filtro de status combinados)
  const q = ordersQuery.toLowerCase().trim()
  const filteredOrders = !q
    ? visibleOrders
    : visibleOrders.filter(o => {
      const drv = o._group ? (s.groups.find(g => g.id === o._group)?.name || '') : ''
      return [o['PEDIDO'], o['CIDADE'], o['UF'], o['CEP'], o['STATUS PED.'], o['TRANSPORTADORA'], drv]
        .map(v => String(v || '').toLowerCase()).join(' ').includes(q)
    })

  // Status groups for orders view
  const byStatus = new Map()
  filteredOrders.forEach(o => {
    const st = (o['STATUS PED.'] || '(sem status)').trim()
    if (!byStatus.has(st)) byStatus.set(st, [])
    byStatus.get(st).push(o)
  })
  if (!s.statusGroupsInitialized && byStatus.size) {
    const sorted = [...byStatus.entries()].sort((a, b) => b[1].length - a[1].length)
    if (sorted.length) s.expandedStatusGroups.add(sorted[0][0])
    s.statusGroupsInitialized = true
  }
  const sortedStatuses = [...byStatus.entries()].sort((a, b) => b[1].length - a[1].length)

  // ── RENDER ────────────────────────────────────────────────────────────────────
  return (
    <>
      <Dashboard title="SantoLog · Mapa de Entregas">
        {auth === 'denied' && <Denied />}
        {
          auth === 'authorized' && <>
            <GlobalMapStyles />
            <PageWrap>

              {/* PROGRESS */}
              <ProgressScreen $visible={screen === 'progress'}>
                <ProgBox>
                  <div className="icon">🛰️</div>
                  <h3>{progress.title}</h3>
                  <p>{progress.sub}</p>
                  <ProgTrack><ProgFill $pct={progress.pct} /></ProgTrack>
                  <ProgMeta><span>{progress.l}</span><span>{progress.r}</span></ProgMeta>
                  <ProgCancel onClick={() => { cancelFlagRef.current = true }}>Cancelar</ProgCancel>
                </ProgBox>
              </ProgressScreen>

              {/* TABS BAR */}
              {screen === 'map' && (
                <TabsBar>
                  <TabBtn $active={currentView === 'map'} onClick={() => switchView('map')}>🗺️ Mapa</TabBtn>
                  <TabBtn $active={currentView === 'orders'} onClick={() => switchView('orders')}>
                    📦 Pedidos
                    <TabBadge $active={currentView === 'orders'}>
                      {selectedStatuses.size > 0
                        ? `${visibleOrders.length}/${s.orders.length}`
                        : s.orders.length}
                    </TabBadge>
                  </TabBtn>
                  <TabBtn $active={currentView === 'areas'} onClick={() => switchView('areas')}>
                    ⬢ Áreas
                    <TabBadge $active={currentView === 'areas'}>{areas.length}</TabBadge>
                  </TabBtn>

                  {/* Status filter chips */}
                  <StatusFilterBar>
                    <StatusFilterLabel>Filtrar status:</StatusFilterLabel>
                    {STATUS_FILTERS.map(f => (
                      <StatusChip
                        key={f.id}
                        $active={selectedStatuses.has(f.id)}
                        onClick={() => toggleStatusFilter(f.id)}
                        title={`Mostrar pedidos com status "${f.label}"`}
                      >
                        {f.label}
                        <StatusChipCount>{statusCounts[f.id] || 0}</StatusChipCount>
                      </StatusChip>
                    ))}
                    {selectedStatuses.size > 0 && (
                      <StatusClearBtn onClick={clearStatusFilter} title="Limpar filtros">
                        ✕ Limpar
                      </StatusClearBtn>
                    )}
                  </StatusFilterBar>
                </TabsBar>
              )}

              {/* MAP SCREEN */}
              <MapScreen $visible={screen === 'map' && currentView === 'map'} >
                <MapWrap>

                  {/* SIDEBAR */}
                  <Sidebar>
                    <StatsRow>
                      <StatCard>
                        <div className="v">{visibleOrders.length}</div>
                        <div className="l">
                          {selectedStatuses.size > 0 ? `de ${s.orders.length} pedidos` : 'pedidos'}
                        </div>
                      </StatCard>
                      <StatCard><div className="v">{fmtKg(totalKg)}</div><div className="l">kg total</div></StatCard>
                      <StatCard><div className="v">{s.groups.length}</div><div className="l">motoristas</div></StatCard>
                    </StatsRow>

                    <GruposHeader>
                      <p>Selecione pedidos no mapa (clique, retângulo ou polígono). Atribua a um motorista existente ou crie um novo.</p>
                      <BtnNewGroup disabled={!selCount} onClick={openModal}>
                        + Criar motorista com seleção
                      </BtnNewGroup>
                    </GruposHeader>

                    <GruposList>
                      {s.groups.length === 0
                        ? <NoGroups>Nenhum motorista criado ainda.<br />Selecione pedidos no mapa e atribua a um motorista.</NoGroups>
                        : s.groups.map(g => {
                          const gOrders = s.orders.filter(o => o._group === g.id)
                          const kg = gOrders.reduce((sum, o) => sum + o._peso, 0)
                          const cidades = new Set(gOrders.map(o => o._key)).size
                          const isOpen = s.expandedGroups.has(g.id)
                          const rs = s.routeState[g.id] || {}
                          const stopOpen = s.openStopsEditor === g.id
                          return (
                            <GCard key={g.id} $color={g.color}>
                              <GCardHead onClick={() => { s.expandedGroups.has(g.id) ? s.expandedGroups.delete(g.id) : s.expandedGroups.add(g.id); rerender() }}>
                                <GChevron $open={isOpen}>▶</GChevron>
                                <GSwatch $color={g.color} />
                                <GName>{g.name}</GName>
                                <GRouteBtnStyled $active={rs.active} onClick={e => { e.stopPropagation(); toggleRoute(g.id) }} title={rs.active ? 'Ocultar rota' : 'Traçar rota'}>
                                  {rs.loading ? '⏳' : '🛣'}
                                </GRouteBtnStyled>
                                <GBtn onClick={e => { e.stopPropagation(); focusGroup(g.id) }} title="Focar no mapa">🎯</GBtn>
                                <GBtn onClick={e => { e.stopPropagation(); openEditModal(g.id) }} title="Renomear">✏️</GBtn>
                                <GBtn $danger onClick={e => { e.stopPropagation(); deleteGroup(g.id) }} title="Excluir">✕</GBtn>
                              </GCardHead>

                              <GStats>
                                <GStat><span>{gOrders.length}</span> pedidos</GStat>
                                <GStat><span>{fmtKg(kg)}</span> kg</GStat>
                                <GStat><span>{cidades}</span> cidades</GStat>
                              </GStats>

                              {/* Route panel */}
                              <GRoutePanel $visible={rs.active || rs.loading}>
                                {rs.loading
                                  ? <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}><RouteSpinner /><span style={{ fontSize: 11, color: '#8a95a3' }}>Calculando rota…</span></div>
                                  : <>
                                    <RouteInfoBar>
                                      <RouteMetric><div className="v">{fmtDistance(rs.distance || 0)}</div><div className="l">distância</div></RouteMetric>
                                      <RouteMetric><div className="v">{rs.straight ? '—' : fmtDuration(rs.duration || 0)}</div><div className="l">tempo</div></RouteMetric>
                                      <RouteMetric><div className="v">{rs.order?.length || 0}</div><div className="l">paradas</div></RouteMetric>
                                    </RouteInfoBar>
                                    {rs.straight && <RouteWarn>⚠ OSRM indisponível — linha reta (distância ~aproximada)</RouteWarn>}
                                    <RouteToggles>
                                      <RouteToggle $checked={rs.optimize} onClick={() => toggleRouteOptimize(g.id)}>
                                        <input type="checkbox" readOnly checked={!!rs.optimize} /> Otimizar ordem
                                      </RouteToggle>
                                      <RouteToggle $checked={rs.returnHome} onClick={() => toggleRouteReturn(g.id)}>
                                        <input type="checkbox" readOnly checked={!!rs.returnHome} /> Retornar ao 🏠
                                      </RouteToggle>
                                    </RouteToggles>
                                    <RouteActions>
                                      <RouteBtn onClick={() => focusRoute(g.id)}>🎯 Ver</RouteBtn>
                                      <RouteBtn onClick={() => drawRoute(g.id)}>↻ Recalcular</RouteBtn>
                                      <RouteBtn $primary onClick={() => openInGoogleMaps(g.id)}>🗺 Maps</RouteBtn>
                                      <RouteBtn onClick={() => { s.openStopsEditor = stopOpen ? null : g.id; rerender() }}>≡ Paradas ▾</RouteBtn>
                                    </RouteActions>
                                    <StopsEditor $open={stopOpen}>
                                      <StopsEditorTitle>
                                        <span>Ordem das paradas</span>
                                        <span className="hint">arraste ⠿⠿ ou use ▲▼ para reordenar</span>
                                      </StopsEditorTitle>
                                      {(rs.order || []).map((stop, i) => (
                                        <RouteStopRow key={stop._id} draggable
                                          onDragStart={e => onStopDragStart(e, g.id, i)}
                                          onDragOver={e => onStopDragOver(e, g.id, i)}
                                          onDragLeave={onStopDragLeave}
                                          onDrop={e => onStopDrop(e, g.id, i)}
                                          onDragEnd={onStopDragEnd}
                                        >
                                          <StopDrag title="Arraste para reordenar">⠿⠿</StopDrag>
                                          <StopNum $color={g.color}>{i + 1}</StopNum>
                                          <StopInfo>
                                            <StopPed title={stop['PEDIDO'] || ''}>{stop['PEDIDO'] || '—'}</StopPed>
                                            <StopCity title={stop['CIDADE'] || ''}>{stop['CIDADE'] || '—'}</StopCity>
                                          </StopInfo>
                                          <StopArrows>
                                            <StopArrow disabled={i === 0} onClick={() => moveStop(g.id, i, i - 1)} title="Subir">▲</StopArrow>
                                            <StopArrow disabled={i === (rs.order.length - 1)} onClick={() => moveStop(g.id, i, i + 1)} title="Descer">▼</StopArrow>
                                          </StopArrows>
                                          <StopLinks>
                                            <a className="waze" href={wazeLinkForStop(stop._lat, stop._lng)} target="_blank" rel="noopener noreferrer" title="Waze">W</a>
                                            <a href={`https://www.google.com/maps/search/?api=1&query=${stop._lat},${stop._lng}`} target="_blank" rel="noopener noreferrer" title="Google Maps">G</a>
                                          </StopLinks>
                                        </RouteStopRow>
                                      ))}
                                    </StopsEditor>
                                  </>
                                }
                              </GRoutePanel>

                              {/* Order list */}
                              <GOrders $open={isOpen}>
                                {gOrders.length === 0
                                  ? <div style={{ padding: '10px 12px', fontSize: 11, color: '#5a6370' }}>Nenhum pedido</div>
                                  : gOrders.map(o => {
                                    const otherGroups = s.groups.filter(x => x.id !== g.id)
                                    const isMenuOpen = s.openMoveMenuId === o._id
                                    return (
                                      <GOrderRow key={o._id}>
                                        <GOrderNum title={o['PEDIDO'] || ''}>{o['PEDIDO'] || '—'}</GOrderNum>
                                        <GOrderKg>{fmtKg(o._peso)} kg</GOrderKg>
                                        <MoveDrop>
                                          <GOrderMove onClick={e => { e.stopPropagation(); s.openMoveMenuId = isMenuOpen ? null : o._id; rerender() }}>⇄</GOrderMove>
                                          <MoveMenu $open={isMenuOpen}>
                                            {otherGroups.map(og => (
                                              <MoveMenuItem key={og.id} onClick={e => { e.stopPropagation(); moveOrder(o._id, og.id) }}>
                                                <span style={{ width: 7, height: 7, borderRadius: '50%', background: og.color, flexShrink: 0, display: 'inline-block' }} /> {og.name}
                                              </MoveMenuItem>
                                            ))}
                                            {otherGroups.length > 0 && <MoveMenuDivider />}
                                            <MoveMenuItem onClick={e => { e.stopPropagation(); moveOrder(o._id, null) }}>
                                              <span style={{ width: 7, height: 7, borderRadius: '50%', background: '#5a6370', flexShrink: 0, display: 'inline-block' }} /> Sem motorista
                                            </MoveMenuItem>
                                          </MoveMenu>
                                        </MoveDrop>
                                      </GOrderRow>
                                    )
                                  })
                                }
                              </GOrders>
                            </GCard>
                          )
                        })
                      }

                      {unassigned.length > 0 && s.groups.length > 0 && (
                        <UnassignedFooter>
                          <span>Sem motorista</span>
                          <span>{unassigned.length} · {fmtKg(unassignedKg)} kg</span>
                        </UnassignedFooter>
                      )}
                    </GruposList>
                  </Sidebar>

                  {/* MAP */}
                  <MapContainer
                    ref={mapContRef}
                    style={{ cursor: s.selMode ? 'crosshair' : 'default' }}
                    onMouseDown={handleContMouseDown}
                    onMouseMove={handleContMouseMove}
                    onMouseUp={handleContMouseUp}
                    onMouseLeave={() => { if (s.boxDrag) { s.boxDrag = false; if (boxRectRef.current) boxRectRef.current.style.display = 'none' } }}
                  >
                    <MapDiv ref={mapDivRef} id="map-canvas" style={{ pointerEvents: s.selMode === 'box' && s.boxDrag ? 'none' : 'all' }} />

                    {/* Box selection rect */}
                    <BoxRect ref={boxRectRef} $visible={false} />

                    {/* Polygon SVG overlay */}
                    <svg ref={polySvgRef} style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', pointerEvents: 'none', zIndex: 900, display: 'none' }}
                      onMouseMove={handlePolySvgMouseMove}
                      onClick={handlePolySvgClick}
                      onDoubleClick={handlePolySvgDblClick}
                    >
                      <polygon ref={polyShapeRef} fill="rgba(0,229,160,0.08)" stroke="#00e5a0" strokeWidth="2" strokeDasharray="6,3" points="" />
                      <polyline ref={polyLineRef} fill="none" stroke="#00e5a0" strokeWidth="2" strokeDasharray="6,3" points="" />
                      <line ref={polyCloseRef} stroke="#00e5a0cc" strokeWidth="1.5" strokeDasharray="4,4" x1="0" y1="0" x2="0" y2="0" />
                      <g ref={polyDotsRef} />
                    </svg>

                    <PolyHint ref={polyHintRef} $visible={false} />

                    <NewBtn onClick={() => { if (window.confirm('Carregar nova planilha? Os dados e grupos serão perdidos.')) window.location.reload() }}>↩ Reiniciar</NewBtn>

                    <MapCtrl>
                      <CtrlBtn onClick={fitAll}>👁 Ver todos</CtrlBtn>
                      <CtrlBtn onClick={goToMyLocation} title="Centralizar no meu local">🏠 Meu local</CtrlBtn>
                      <CtrlBtn $active={s.selMode === 'box'} onClick={() => { if (s.selMode === 'box') { exitMode() } else { if (s.selMode === 'poly') exitMode(); enterMode('box') } }}>⬚ Retângulo</CtrlBtn>
                      <CtrlBtn $active={s.selMode === 'poly'} onClick={() => { if (s.selMode === 'poly') { exitMode() } else { if (s.selMode === 'box') exitMode(); enterMode('poly') } }}>⬡ Polígono</CtrlBtn>
                      {areas.length > 0 && (
                        <CtrlBtn $active={showAreas} onClick={() => setShowAreas(v => !v)} title="Mostrar/ocultar áreas no mapa">
                          ⬢ Áreas {showAreas ? 'on' : 'off'}
                        </CtrlBtn>
                      )}
                      <CtrlBtn onClick={clearCache}>🗑 Limpar cache</CtrlBtn>
                    </MapCtrl>

                    <MapStatus>
                      {selectedStatuses.size > 0
                        ? `${visibleOrders.length}/${s.orders.length} pedidos visíveis`
                        : s.mapStatus}
                    </MapStatus>

                    {/* Selection bar */}
                    <SelBar $visible={selCount > 0}>
                      <SelInfo>
                        <SelCount>{selCount} pedido{selCount !== 1 ? 's' : ''} selecionado{selCount !== 1 ? 's' : ''}</SelCount>
                        <SelWeight>Peso total: <strong>{fmtKg(selWeightV)} kg</strong></SelWeight>
                        <SelReassignInfo $visible={selAssigned.length > 0}>
                          ⚠ {selAssigned.length} já atribuído{selAssigned.length > 1 ? 's' : ''}
                        </SelReassignInfo>
                      </SelInfo>
                      <SelActions>
                        <SelClear onClick={clearSelection}>✕ Limpar</SelClear>
                        <SelAssignWrap>
                          <SelAssign disabled={!s.groups.length} onClick={() => { s.assignMenuOpen = !s.assignMenuOpen; rerender() }}>
                            Atribuir a motorista ▾
                          </SelAssign>
                          <AssignMenu $open={s.assignMenuOpen}>
                            <AssignMenuTitle>Atribuir seleção a:</AssignMenuTitle>
                            {s.groups.map(g => {
                              const cnt = s.orders.filter(o => o._group === g.id).length
                              const kg = s.orders.filter(o => o._group === g.id).reduce((sum, o) => sum + o._peso, 0)
                              return (
                                <AssignMenuItem key={g.id} onClick={e => { e.stopPropagation(); assignToExistingGroup(g.id) }}>
                                  <span style={{ width: 8, height: 8, borderRadius: '50%', background: g.color, flexShrink: 0, display: 'inline-block' }} />
                                  {g.name}
                                  <span className="g-cnt">{cnt} · {fmtKg(kg)}kg</span>
                                </AssignMenuItem>
                              )
                            })}
                          </AssignMenu>
                        </SelAssignWrap>
                        <SelCreate onClick={openModal}>+ Novo motorista</SelCreate>
                      </SelActions>
                    </SelBar>
                  </MapContainer>

                </MapWrap>
              </MapScreen>

              {/* ORDERS SCREEN */}
              <OrdersScreen $visible={screen === 'map' && currentView === 'orders'}>
                <OrdersToolbar>
                  <OrdersSearch
                    value={ordersQuery}
                    onChange={e => setOrdersQuery(e.target.value)}
                    placeholder="Buscar por pedido, cidade, motorista, CEP…"
                  />
                  <OrdersToolbarActions>
                    <OrdersToolBtn onClick={() => { sortedStatuses.forEach(([st]) => s.expandedStatusGroups.add(st)); rerender() }}>▼ Expandir tudo</OrdersToolBtn>
                    <OrdersToolBtn onClick={() => { s.expandedStatusGroups = new Set(); rerender() }}>▶ Recolher tudo</OrdersToolBtn>
                  </OrdersToolbarActions>
                </OrdersToolbar>
                <OrdersContent>
                  {filteredOrders.length === 0
                    ? <OrdersEmpty><div className="big">🔍</div>{q ? `Nenhum resultado para "${q}"` : 'Nenhum pedido carregado'}</OrdersEmpty>
                    : sortedStatuses.map(([status, items]) => {
                      const color = getStatusColor(status)
                      const kg = items.reduce((sum, o) => sum + o._peso, 0)
                      const isOpen = s.expandedStatusGroups.has(status)
                      return (
                        <StatusGroup key={status} $color={color}>
                          <StatusGroupHead onClick={() => { isOpen ? s.expandedStatusGroups.delete(status) : s.expandedStatusGroups.add(status); rerender() }}>
                            <StatusGroupChevron $open={isOpen}>▶</StatusGroupChevron>
                            <StatusGroupName>{status}</StatusGroupName>
                            <StatusGroupMetrics>
                              <span><strong>{items.length}</strong> pedido{items.length !== 1 ? 's' : ''}</span>
                              <span><strong>{fmtKg(kg)}</strong> kg</span>
                            </StatusGroupMetrics>
                          </StatusGroupHead>
                          <StatusGroupBody $open={isOpen}>
                            <OrdersTable>
                              <thead>
                                <tr>
                                  <th>Pedido</th><th>Motorista</th><th>Cidade / UF</th>
                                  <th>CEP</th><th>DT Criação</th><th>Prev. Entrega</th>
                                  <th style={{ textAlign: 'right' }}>Peso</th><th>Transportadora</th>
                                </tr>
                              </thead>
                              <tbody>
                                {items.map(o => {
                                  const driver = o._group ? s.groups.find(g => g.id === o._group) : null
                                  const cep = String(o['CEP'] || '').replace(/\D/g, '').replace(/(\d{5})(\d{3})/, '$1-$2')
                                  return (
                                    <tr key={o._id} onClick={() => focusOrderOnMap(o._id)} title="Ver no mapa">
                                      <ColPed>{o['PEDIDO'] || '—'}</ColPed>
                                      <td>
                                        {driver
                                          ? <DriverPill $color={driver.color}><span className="dot" /><span className="name">{driver.name}</span></DriverPill>
                                          : <DriverNone>Sem motorista</DriverNone>
                                        }
                                      </td>
                                      <ColCidade>{o['CIDADE'] || '—'}/{o['UF'] || '—'}</ColCidade>
                                      <ColCep>{cep || '—'}</ColCep>
                                      <ColDate>{o['DT CRIAÇÃO'] || '—'}</ColDate>
                                      <ColDate>{o['DT ENTREGA EST.'] || '—'}</ColDate>
                                      <ColPeso>{fmtKg(o._peso)} kg</ColPeso>
                                      <ColTransp title={o['TRANSPORTADORA'] || ''}>{o['TRANSPORTADORA'] || '—'}</ColTransp>
                                    </tr>
                                  )
                                })}
                              </tbody>
                            </OrdersTable>
                          </StatusGroupBody>
                        </StatusGroup>
                      )
                    })
                  }
                </OrdersContent>
              </OrdersScreen>

              {/* AREAS SCREEN — estatísticas por zona */}
              <AreasScreen $visible={screen === 'map' && currentView === 'areas'}>
                <AreasToolbar>
                  <AreasSummary>
                    <ASumStat><strong>{areas.length}</strong>áreas</ASumStat>
                    <ASumStat>
                      <strong>{ordersInAnyArea}</strong>pedidos cobertos
                      {visibleOrders.length > 0 && (
                        <span className="muted">
                          {' '}/ {visibleOrders.length}
                          {selectedStatuses.size > 0 ? ' filtrados' : ' total'}
                        </span>
                      )}
                    </ASumStat>
                    <ASumStat><strong>{fmtKg(weightInAnyArea)}</strong>kg em área</ASumStat>
                    <ASumStat $warn={ordersOutOfAreas > 0}>
                      <strong>{ordersOutOfAreas}</strong>pedidos fora · <strong>{fmtKg(weightOutOfAreas)}</strong>kg
                    </ASumStat>
                  </AreasSummary>
                </AreasToolbar>

                <AreasContent>
                  {!areas.length && (
                    <AreasEmpty>
                      Nenhuma área cadastrada. Cadastre em <strong>SantoLog → Mapa → Áreas</strong>.
                    </AreasEmpty>
                  )}

                  {areasWithStats
                    .slice()
                    .sort((a, b) => b.orderCount - a.orderCount)
                    .map(a => {
                      const pct = visibleOrders.length ? (a.orderCount / visibleOrders.length * 100) : 0
                      return (
                        <AreaStatCard key={a.id} $color={a.color}>
                          <AreaStatHead>
                            <AreaStatSwatch $color={a.color} />
                            <AreaStatName>{a.name}</AreaStatName>
                            {a.carrier_name && (
                              <AreaStatCarrier>🚚 {a.carrier_name}</AreaStatCarrier>
                            )}
                            {a.driver_name && (
                              <AreaStatCarrier>👤 {a.driver_name}</AreaStatCarrier>
                            )}
                          </AreaStatHead>
                          <AreaStatRow>
                            <AreaStatMetric>
                              <span className="lbl">Pedidos</span>
                              <span className="val">{a.orderCount}</span>
                              <span className="muted">{pct.toFixed(1).replace('.', ',')}%</span>
                            </AreaStatMetric>
                            <AreaStatMetric>
                              <span className="lbl">Peso total</span>
                              <span className="val">{fmtKg(a.totalWeight)} <em>kg</em></span>
                            </AreaStatMetric>
                            <AreaStatMetric>
                              <span className="lbl">Peso médio/pedido</span>
                              <span className="val">
                                {a.orderCount ? fmtKg(a.totalWeight / a.orderCount) : '0,0'} <em>kg</em>
                              </span>
                            </AreaStatMetric>
                          </AreaStatRow>
                          <AreaStatBar>
                            <AreaStatBarFill $pct={pct} $color={a.color} />
                          </AreaStatBar>
                        </AreaStatCard>
                      )
                    })}

                  {ordersOutOfAreas > 0 && (
                    <AreaStatCard $color="#5a6370" $muted>
                      <AreaStatHead>
                        <AreaStatSwatch $color="#5a6370" />
                        <AreaStatName>Fora de qualquer área</AreaStatName>
                      </AreaStatHead>
                      <AreaStatRow>
                        <AreaStatMetric>
                          <span className="lbl">Pedidos</span>
                          <span className="val">{ordersOutOfAreas}</span>
                        </AreaStatMetric>
                        <AreaStatMetric>
                          <span className="lbl">Peso total</span>
                          <span className="val">{fmtKg(weightOutOfAreas)} <em>kg</em></span>
                        </AreaStatMetric>
                      </AreaStatRow>
                    </AreaStatCard>
                  )}
                </AreasContent>
              </AreasScreen>

            </PageWrap>

            {/* MODAL */}
            <ModalOverlay $open={modalOpen} onClick={e => { if (e.target === e.currentTarget) closeModal() }}>
              <ModalBox>
                <h3>{s.editingGroupId ? 'Editar motorista' : 'Criar motorista'}</h3>
                <p>{s.editingGroupId ? 'Renomeie ou gerencie os pedidos do motorista.' : 'Defina um nome para o motorista responsável pelos pedidos selecionados.'}</p>
                {!s.editingGroupId && (
                  <ModalSummary>
                    <MStat><strong>{selCount}</strong>pedidos</MStat>
                    <MStat><strong>{fmtKg(selWeightV)}</strong>kg total</MStat>
                    <MStat><strong>{new Set(selOrders.map(o => o._key)).size}</strong>cidades</MStat>
                  </ModalSummary>
                )}
                {s.editingGroupId && (() => {
                  const gOrds = s.orders.filter(o => o._group === s.editingGroupId)
                  const gKg = gOrds.reduce((sum, o) => sum + o._peso, 0)
                  return (
                    <ModalSummary>
                      <MStat><strong>{gOrds.length}</strong>pedidos</MStat>
                      <MStat><strong>{fmtKg(gKg)}</strong>kg total</MStat>
                      <MStat><strong>{new Set(gOrds.map(o => o._key)).size}</strong>cidades</MStat>
                    </ModalSummary>
                  )
                })()}
                <label>Nome do motorista</label>
                <input
                  value={modalInput}
                  onChange={e => setModalInput(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && confirmModal()}
                  placeholder="Ex: João Silva"
                  autoFocus
                />
                <ModalEditActions $visible={!!s.editingGroupId}>
                  <div className="label">Ações adicionais</div>
                  <div className="row">
                    <BtnAddSel disabled={!selOrders.filter(o => !o._group).length} onClick={addSelectionToEditing}>
                      + Adicionar seleção ({selOrders.filter(o => !o._group).length})
                    </BtnAddSel>
                    <BtnEmptySel onClick={removeAllFromEditing}>✕ Esvaziar</BtnEmptySel>
                  </div>
                </ModalEditActions>
                <ModalActions>
                  <ModalCancel onClick={closeModal}>Cancelar</ModalCancel>
                  <ModalConfirm onClick={confirmModal}>Salvar</ModalConfirm>
                </ModalActions>
              </ModalBox>
            </ModalOverlay>
          </>}
      </Dashboard>
    </>
  )
}
